import React from 'react';
import Heading from '../../../generic-components/Heading';
import Button from '../../../generic-components/Button';
import { UserMessage } from '../../../DesignSystem/LiliUserMessage/UserMessage';
import { ReactComponent as ErrorIcon } from '../../../assets/icons/svg/stamp-icons/ic-stamp-alert.svg';

interface IProps {
  errMsg: string;
  onClose: () => void;
}

export const DeleteVendorError = ({ errMsg, onClose }: IProps) => (
  <UserMessage onClick={onClose} id=''>
    <div className='py-[24px] px-[24px] flex flex-col items-center bg-bw00 shadow-bottomShadow rounded-[8px] fadeIn'>
      <ErrorIcon className='mb-[20px]' />
      <Heading title='You can’t delete this recipient' className=' font-metricRMedium text-[18px] text-bw08 mb-[6px]' />
      <Heading title={errMsg} className='font-metricR text-[16px] text-bw07 max-w-[270px] text-center mb-[22px]' />
      <Button
        onClick={onClose}
        title='Got it'
        className='bg-action03 hover:bg-action04 w-full py-[12px] rounded-[4px] font-metricRMedium text-[16px] text-bw00'
        id='closePopup'
      />
    </div>
  </UserMessage>
);
